import React from 'react';
import {connect} from "react-redux";

import ShoppingCartDiscountsListItem from "./shoppingCartDiscountsListItem";
import {
  discountSectionExistsInCurrentWizardSelections,
  getDiscountsForSection,
  getFilteredSections,
  shouldDisplayDiscount
} from "../priceWorksheet/discountFunctions";
import {sortByOrder} from "../../misc/helpers";
import {DISCOUNT_MAIN_TYPES} from "../priceWorksheet/discounstInterface";

class ShoppingCartDiscountsList extends React.Component {

  getDiscountTitle = () => {
    // formattedMessage is not working here (not sure why)
    switch (this.props.language) {
      case "fr-FR":
        return "Rabais -"
      case "pl-PL":
        return "Obniżki -"
      case "es-ES":
        return "Descuento -"
    }
    return "Discount -"
  }

  render() {
    const {activeQuoteIndex, hasMultipleWorkSheets, hideTotalPricesBeforeWSOpened} = this.props;
    const showPriceWorksheet = this.props.discountSections.length && document.kvConfig.isBackend || document.kvConfig.jobId;

    if (showPriceWorksheet && !hideTotalPricesBeforeWSOpened) {
      return getFilteredSections(this.props.discountSections).map((discountSection, discountSectionIndex) => {
        if (!discountSectionExistsInCurrentWizardSelections(
          discountSection,
          this.props.allWizardsValues,
          activeQuoteIndex)
        ) {
          return null
        }
        const allDiscounts = getDiscountsForSection(discountSection, this.props.customAddedDiscounts);
        const displayDiscounts = sortByOrder(allDiscounts.filter(discount => {
          return shouldDisplayDiscount(discount, activeQuoteIndex, hasMultipleWorkSheets)
            || discount.discountType === DISCOUNT_MAIN_TYPES.deposit || discount.discountType === DISCOUNT_MAIN_TYPES.downPayment
        }));
        if (!displayDiscounts.length) {
          return null
        }
        return (
          <div key={discountSectionIndex} className={"scart-block"}>
            <h3 className="scart-block__title scart-block__title--discounts">
              {this.getDiscountTitle()} {discountSection.name}
            </h3>
            <ul className="scart-block__list">
              {displayDiscounts.map((discount, discountIndex) => {
                return <ShoppingCartDiscountsListItem key={"dis" + discountSectionIndex + discountIndex}
                                                      discountSection={discountSection}
                                                      quoteIndex={activeQuoteIndex}
                                                      hasMultipleWorkSheets={hasMultipleWorkSheets}
                                                      discount={discount}/>
              })}
            </ul>
          </div>
        )
      })
    }
    return null
  }
}

const mapStateToProps = (store, ownProps) => {
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex} = store.quotesState;
  const {discountSections, customAddedDiscounts} = store.priceWorksheetState;
  const {language} = store.serverState;
  const {hideTotalPricesBeforeWSOpened} = store.cartState;

  return {
    discountSections,
    customAddedDiscounts,
    language,
    allWizardsValues,
    activeQuoteIndex: Number.isInteger(ownProps.quoteIndex) ? ownProps.quoteIndex : activeQuoteIndex,
    hideTotalPricesBeforeWSOpened,
  };
};

export default connect(mapStateToProps, {

})(ShoppingCartDiscountsList);
